import { render } from "./CharacterCreation.vue?vue&type=template&id=671193b6"
import script from "./CharacterCreation.vue?vue&type=script&lang=js"
export * from "./CharacterCreation.vue?vue&type=script&lang=js"

import "./CharacterCreation.vue?vue&type=style&index=0&id=671193b6&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__